import {
  CardDescription,
  CardGridContainer,
  CardsGrid,
  CardTitle,
  QuestionnaireCard,
} from './ManualIntakeDynamicQuestions.styles';
import { sanitizeQuestionnaireDescription } from './sanitizeQuestionnaireDescription';

export type QuestionnaireListItem = {
  id: string;
  publicTitle?: string | null;
  internalName?: string | null;
  description?: string | null;
  categoryId?: number | null;
};

type ManualIntakeQuestionnaireSelectorProps = {
  questionnaires: QuestionnaireListItem[];
  canSelectQuestionnaire: boolean;
  onSelect: (
    questionnaireId: string,
    questionnaireName: string | null | undefined,
    questionnaireDescription: string | null | undefined,
    questionnaireCategoryId: number | null | undefined,
  ) => void;
};

export function ManualIntakeQuestionnaireSelector({
  questionnaires,
  canSelectQuestionnaire,
  onSelect,
}: ManualIntakeQuestionnaireSelectorProps) {
  return (
    <CardGridContainer>
      <CardsGrid>
        {questionnaires.map((q) => (
          <QuestionnaireCard
            key={q.id}
            type="button"
            $selected={false}
            disabled={!canSelectQuestionnaire}
            onClick={() =>
              onSelect(
                q.id,
                q.publicTitle || q.internalName,
                q.description,
                q.categoryId,
              )
            }
            data-testid={`manual-intake-questionnaire-card-${q.id}`}
          >
            <CardTitle>{q.publicTitle || q.internalName}</CardTitle>
            {q.description && (
              <CardDescription>
                {sanitizeQuestionnaireDescription(q.description)}
              </CardDescription>
            )}
          </QuestionnaireCard>
        ))}
      </CardsGrid>
    </CardGridContainer>
  );
}
